import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { PostHogProvider } from '@posthog/react';
import { Provider } from 'react-redux';
import { isPostHogConfigured, posthog } from './app/analytics/posthog.ts';
import App from './app/pages/root/App.tsx';
import { store } from './app/store.ts';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-phone-number-input/style.css';
import { PageLoadingProvider } from './app/components/page-loading.tsx';

const appTree = (
  <StrictMode>
    <Provider store={store}>
      <PageLoadingProvider>
        <App />
      </PageLoadingProvider>
    </Provider>
  </StrictMode>
);

// biome-ignore lint/style/noNonNullAssertion: ignore
createRoot(document.getElementById('root')!).render(
  isPostHogConfigured ? <PostHogProvider client={posthog}>{appTree}</PostHogProvider> : appTree,
);
